// extracted by mini-css-extract-plugin
export default {"root":"BannerButton-module-root","box":"BannerButton-module-box"};